var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#25D366"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_598_494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 26,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.90283H32.2549V32.1087H7V6.90283Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_598_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0067 7.08885L21.2491 6.98272C18.9721 6.65459 16.6485 6.97921 14.5493 7.91874C12.45 8.85826 10.6616 10.374 9.39257 12.2892C8.0423 14.1199 7.23738 16.2939 7.07042 18.5611C6.90346 20.8282 7.38126 23.0963 8.44883 25.1044C8.55809 25.3056 8.62611 25.5266 8.64893 25.7544C8.67175 25.9821 8.64892 26.2121 8.58175 26.431C8.03678 28.3015 7.53168 30.1853 7 32.162L7.6646 31.963C9.45903 31.4854 11.2535 31.0078 13.0479 30.5701C13.4266 30.4915 13.8203 30.5285 14.1777 30.6762C15.7876 31.4604 17.547 31.8918 19.3377 31.9415C21.1285 31.9912 22.9092 31.6581 24.5603 30.9644C26.2114 30.2707 27.6947 29.2326 28.9107 27.9196C30.1268 26.6067 31.0473 25.0493 31.6107 23.3521C32.174 21.6549 32.3671 19.857 32.177 18.0791C31.9868 16.3013 31.4178 14.5846 30.5082 13.0443C29.5986 11.5039 28.3694 10.1756 26.9031 9.14846C25.4368 8.1213 23.7673 7.41905 22.0067 7.08885ZM25.3563 24.4941C24.8732 24.9258 24.2841 25.222 23.649 25.3525C23.0139 25.483 22.3555 25.4431 21.7409 25.237C18.9561 24.4532 16.54 22.7093 14.9221 20.3153C14.3042 19.4683 13.8076 18.5396 13.4466 17.5559C13.2511 16.9851 13.2158 16.3718 13.3447 15.7825C13.4735 15.1932 13.7616 14.6503 14.1777 14.2128C14.3803 13.9548 14.656 13.7637 14.9689 13.6643C15.2819 13.5649 15.6176 13.5619 15.9323 13.6556C16.1981 13.722 16.3842 14.1067 16.6234 14.3985C16.8184 14.9469 17.0444 15.4819 17.3013 16.0037C17.496 16.2697 17.5772 16.6018 17.5274 16.9274C17.4776 17.253 17.3008 17.5457 17.0355 17.7416C16.4374 18.2723 16.5304 18.7101 16.9557 19.307C17.8956 20.6596 19.1932 21.7251 20.7041 22.3848C21.1294 22.5705 21.4484 22.6103 21.7276 22.1725C21.8472 22.0001 22.0067 21.8542 22.1396 21.695C22.9106 20.7265 22.6713 20.7398 23.8942 21.2704C24.2841 21.4341 24.6607 21.6242 25.024 21.8409C25.3829 22.0531 25.9279 22.2787 26.0076 22.5971C26.0844 22.9425 26.0642 23.3023 25.9492 23.637C25.8343 23.9717 25.6292 24.2683 25.3563 24.4941Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaIcon);
export default __webpack_public_path__ + "static/media/wa_icon.adc6db6531d70ab53875d42215f4d1a7.svg";
export { ForwardRef as ReactComponent };